import * as z from "zod";

export const executeCodeSummarySchema = z
  .string()
  .trim()
  .min(1)
  .describe(
    "Merchant-facing description of what this call will show or change. 1-3 sentences. Never mention RPC names, JSON, field names, or internal IDs.",
  );
